import { render, staticRenderFns } from "./myr.vue?vue&type=template&id=24d17b82&scoped=true"
import script from "./myr.vue?vue&type=script&lang=js"
export * from "./myr.vue?vue&type=script&lang=js"
import style0 from "./myr.vue?vue&type=style&index=0&id=24d17b82&prod&lang=css"
import style1 from "./myr.vue?vue&type=style&index=1&id=24d17b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d17b82",
  null
  
)

export default component.exports